<template>
  <p>
    <a @click="click"
       class="cps-select-form-item change-show-style"
       :class="{'cps-dropdown-disabled': disabled}">
      {{ operateName }}
      <div class="cps-form-tip cps-form-tip-restart"
           v-if="disabled">
        {{ operateTip }}
      </div>
    </a>
  </p>
</template>

<script>
export default {
  name: 'OperateUnit',
  props: {
    operateName: {
      type: String,
      default: ''
    },
    operateTip: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    instanceInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {

    };
  },
  methods: {
    click() {
      this.$emit('handleClick', this.disabled, this.instanceInfo);
    }
  },
};
</script>

<style scoped>
  .change-show-style {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/privateNetInstance/operateUnit/OperateUnit.vue